import {
  Box,
  Button,
  Flex,
  Heading,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from '@chakra-ui/react';
import ProgressBar from '@ramonak/react-progress-bar';
import moment from 'moment';
import Loader from '../../Loader';
import LogTtePengetahuan from './LogTtePengetahuan';
import { useManajemenSertifikatContext } from '../../../controller/admin/manajemen_sertifikat';
import DataTable from 'react-data-table-component';
import { useEffect } from 'react';
import { IoChevronDown } from 'react-icons/io5';

const TabTtePengetahuan = () => {
  const {
    pagePengetahuan,
    perPagePengetahuan,
    isLoadingTTEPengetahuan,
    sertifikatPengetahuanData,
    sertifikatPengetahuanTotal,
  } = useManajemenSertifikatContext().state;

  const {
    getDataTTEPengetahuan,
    setPagePengetahuan,
    setPerPagePengetahuan,
    setShowDialog,
    setPengetahuanId,
    setTteType,
    setTteUlang,
  } = useManajemenSertifikatContext();

  // TTE Sertifikat Pengetahuan
  const columnsSertifikatPengetahuan = [
    {
      name: 'No.',
      selector: (row, index) =>
        (pagePengetahuan - 1) * perPagePengetahuan + (index + 1),
      grow: 0,
    },
    {
      name: 'Nama Pengetahuan',
      selector: (row) => row.title,
      wrap: true,
    },
    {
      name: 'Waktu Pelaksanaan',
      selector: (row) => {
        return (
          <>
            <p>
              {moment(row.waktu_mulai).format('DD-MM-YYYY')} sd <br />{' '}
              {moment(row.waktu_selesai).format('DD-MM-YYYY')}
            </p>
          </>
        );
      },
      wrap: true,
    },
    {
      name: 'Presentase TTE',
      cell: (row) => {
        return (
          <ProgressBar
            completed={row.persentase_tte}
            maxCompleted={row.persentase_tte}
            className="w-full"
            height="14px"
            bgColor="#007E39"
            animateOnRender={true}
          />
        );
      },
      width: '200px',
      wrap: true,
    },
    {
      name: 'Jumlah Peserta Lulus',
      cell: (row) => {
        return <>{row.count_peserta_selesai ?? 0}</>;
      },
      wrap: true,
    },
    {
      name: 'Action',
      selector: (row) => {
        return (
          <>
            <Flex flexDirection="column" gridGap={2} my={2}>
              <Menu closeOnSelect={false}>
                <MenuButton
                  as={Button}
                  colorScheme="green"
                  rightIcon={<IoChevronDown />}
                  size="md"
                >
                  TTE Peserta
                </MenuButton>
                <Portal>
                  <MenuList>
                    <MenuItem
                      onClick={() => {
                        setShowDialog(true);
                        setPengetahuanId(row.id);
                        setTteType('pengetahuan');
                        setTteUlang(false);
                      }}
                    >
                      TTE Sertifikat
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setShowDialog(true);
                        setPengetahuanId(row.id);
                        setTteType('pengetahuan');
                        setTteUlang(true);
                      }}
                    >
                      TTE Ulang Sertifikat
                    </MenuItem>
                  </MenuList>
                </Portal>
              </Menu>
              <Menu closeOnSelect={false}>
                <MenuButton
                  as={Button}
                  colorScheme="blue"
                  rightIcon={<IoChevronDown />}
                  size="md"
                >
                  TTE Pemateri
                </MenuButton>
                <Portal>
                  <MenuList>
                    <MenuItem
                      onClick={() => {
                        setShowDialog(true);
                        setPengetahuanId(row.id);
                        setTteType('pemateri');
                        setTteUlang(false);
                      }}
                    >
                      TTE Sertifikat Pemateri
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setShowDialog(true);
                        setPengetahuanId(row.id);
                        setTteType('pemateri');
                        setTteUlang(true);
                      }}
                    >
                      TTE Ulang Sertifikat Pemateri
                    </MenuItem>
                  </MenuList>
                </Portal>
              </Menu>
            </Flex>
          </>
        );
      },
      wrap: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#F2FFFB',
        fontWeight: '600',
        fontSize: '13px',
      },
    },
  };

  useEffect(() => {
    getDataTTEPengetahuan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagePengetahuan, perPagePengetahuan]);

  const handlePageChange = (pagePengetahuan) => {
    setPagePengetahuan(pagePengetahuan);
  };

  const handlePerRowsChange = async (newPerPage, pagePengetahuan) => {
    setPagePengetahuan(pagePengetahuan);
    setPerPagePengetahuan(newPerPage);
  };

  return (
    <>
      {/* Table Data Pengetahuan */}
      <Box bg="white" p={5} borderRadius="lg" mb={5} shadow="lg">
        <Heading
          as="h4"
          fontSize="xl"
          fontWeight="semibold"
          mb={5}
          className="text-xl font-semibold mb-5"
        >
          Data Pengetahuan
        </Heading>
        <DataTable
          columns={columnsSertifikatPengetahuan}
          data={sertifikatPengetahuanData}
          progressPending={isLoadingTTEPengetahuan}
          pagination
          paginationServer
          paginationTotalRows={
            sertifikatPengetahuanData.length > 0
              ? sertifikatPengetahuanTotal
              : 0
          }
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          customStyles={customStyles}
          progressComponent={<Loader />}
        />
      </Box>

      {/* Table Log TTE Pengetahuan */}
      <LogTtePengetahuan />
    </>
  );
};

export default TabTtePengetahuan;
